import { useEffect } from "react";
import { useState, useRef } from "react";
import { useQueryClient } from "react-query";

export default function useEditMode({
  editModeEnabled,
  updateMutation,
  initialQueryKey,
  specificUpdateKey,
}) {
  const [editedObject, setEditedObject] = useState(null);
  const previousData = useRef(null);
  const [editMode, setEditMode] = useState(editModeEnabled);
  const queryClient = useQueryClient();
  const queryKey = useRef(initialQueryKey);

  const setQueryKey = (_queryKey) => {
    queryKey.current = [..._queryKey];
  };

  const updateEditState = (id, val) => {
    setEditedObject((prevState) => {
      let updatedState = {};
      if (specificUpdateKey !== undefined) {
        updatedState = {
          ...prevState,
          [specificUpdateKey]: {
            ...prevState[[specificUpdateKey]],
            [id]: val,
          },
        };
      } else {
        updatedState = {
          ...prevState,
          [id]: val,
        };
      }

      // updates query data for the rendering
      updateQueryData(updatedState);

      // updates the actual state
      return updatedState;
    });
  };

  const enterEditMode = (id) => {
    setEditMode(id);
    const prevData = queryClient.getQueryData([...queryKey.current]);
    previousData.current =
      prevData === undefined
        ? {
            id: [...queryKey.current].find((el) => typeof el === "number"),
          }
        : prevData;
    setEditedObject(previousData.current);
  };

  const cancelEditMode = () => {
    setEditMode(false);
    setEditedObject(previousData.current);
    restorePreviousData();
  };

  const confirmEditMode = () => {
    setEditMode(false);
    updateMutation.mutate(editedObject, {
      onError: (data, variables, context) => {
        console.log("restoring data...");
        restorePreviousData();
      },
    });
  };

  const updateQueryData = (updatedState) => {
    queryClient.setQueryData(queryKey.current, (oldData) => {
      return {
        ...oldData,
        ...updatedState,
      };
    });
  };

  const restorePreviousData = () => {
    queryClient.invalidateQueries(queryKey.current);

    // might be useful for queries with "enabled" since they dont get refreshed
    queryClient.setQueryData(queryKey.current, previousData);
  };

  return {
    editMode,
    enterEditMode,
    cancelEditMode,
    confirmEditMode,
    updateEditState,
    setQueryKey,
  };
}
